export default {"src":"/_next/static/media/disc-wheels.20b0dfcf.svg","height":354,"width":478,"blurWidth":0,"blurHeight":0};